export default {
    name: 'BoardCutLine',
    props: {
        cutLineText: {
            type: String,
            required: true
        }
    }
};
